import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const CreateLand = ({ onSubmit }) => {
    const { id } = useParams(); // Residential property id (not used directly here)
    const [landLegalDesc, setLandLegalDesc] = useState('');
    const [landTaxDistrict, setLandTaxDistrict] = useState('');
    const [landParcelNo, setLandParcelNo] = useState('');
    const [landLotNo, setLandLotNo] = useState('');
    const [landPlatNo, setLandPlatNo] = useState('');
    const [landAreaAcres, setLandAreaAcres] = useState('');
    const [error, setError] = useState('');

    // Form submission handler
    const handleSubmit = async (event) => {
        event.preventDefault();

        const newLandData = {
            asset_type_1: 'physical_asset',
            asset_type_2: 'land',
            legal_description: landLegalDesc,
            tax_district: landTaxDistrict,
            parcel_number: landParcelNo,
            lot_number: landLotNo ? parseInt(landLotNo) : null,
            plat_number: landPlatNo ? parseInt(landPlatNo) : null,
            area_in_acres: landAreaAcres ? parseFloat(landAreaAcres) : null,
        };

        try {
            await onSubmit(newLandData);
        } catch (e) {
            setError('Failed to submit.');
        }
    };

    // Two-column layout with consistent alignment
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 12,
    };
    const groupStyle = { display: 'flex', flexDirection: 'column' };
    const labelStyle = { fontWeight: 600, marginBottom: 6 };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div style={gridStyle}>
                    <div style={groupStyle}>
                        <label style={labelStyle} htmlFor="legalDesc">Legal Description</label>
                        <input id="legalDesc" type="text" className="form-control" value={landLegalDesc} onChange={(e) => setLandLegalDesc(e.target.value)} required />
                    </div>
                    <div style={groupStyle}>
                        <label style={labelStyle} htmlFor="taxDistrict">Tax District</label>
                        <input id="taxDistrict" type="text" className="form-control" value={landTaxDistrict} onChange={(e) => setLandTaxDistrict(e.target.value)} required />
                    </div>
                    <div style={groupStyle}>
                        <label style={labelStyle} htmlFor="parcelNo">Parcel Number</label>
                        <input id="parcelNo" type="text" className="form-control" value={landParcelNo} onChange={(e) => setLandParcelNo(e.target.value)} required />
                    </div>
                    <div style={groupStyle}>
                        <label style={labelStyle} htmlFor="lotNo">Lot Number</label>
                        <input id="lotNo" type="number" className="form-control" value={landLotNo} onChange={(e) => setLandLotNo(e.target.value)} required />
                    </div>
                    <div style={groupStyle}>
                        <label style={labelStyle} htmlFor="platNo">Plat Number</label>
                        <input id="platNo" type="number" className="form-control" value={landPlatNo} onChange={(e) => setLandPlatNo(e.target.value)} required />
                    </div>
                    <div style={groupStyle}>
                        <label style={labelStyle} htmlFor="areaAcres">Area in Acres</label>
                        <input id="areaAcres" type="number" step="0.01" className="form-control" value={landAreaAcres} onChange={(e) => setLandAreaAcres(e.target.value)} required />
                    </div>
                </div>
                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <button type="submit" className="btn btn-success">Create Land</button>
                </div>
            </form>
            {error && <div className="alert alert-danger" style={{ marginTop: 12 }}>{error}</div>}
        </div>
    );
};

export default CreateLand;